import '../styles/home.css';
import '../styles/faq.css';

import React, { useEffect, useState } from 'react';

import Faq from '../components/Faq';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

//Import Styles

//Import components

const Home = ({ openseaURL, user }) => {
  <div className="homeTitle">Welcome To My Website!</div>;

  //  const Products = () => {
  //Set a state for the FAQs
  const [faqs, setFaqs] = useState([
    {
      question: 'What do you like to do ?',
      answer: `I like to have fun like any guy. I love to visit the beach and my girlfriends. 
             We have fun going to restaurants and visit often. I am single and not in a relationship now since my
             girlfriend in in another state. I go to Woodland Hills and Westwood and watch movies and after 
             go to local restaurant bars and have fun! Wanna meetup and have some fun. Call or email me to meet soon!`,
      id: 1,
    },
    {
      question: 'What kind of work do you do daily',
      answer: `I am a Software Developer and create websites and mobile apps. I am writing my resume, website
             and mobile app. Projects I work on include MyOneUniverse, a six website anthology of websites, tablet,
             phone, and watch app. My latest electronic device is an Apple Series 7 Watch.`,
      id: 2,
    },

    {
      question: 'Excercise, Daily, Walk locally and at Malls',
      answer: `I visit Woodland Hills and Northridge malls. I walk a mile or so at a time and feel good about it.
             After I go to restaurants. Sometimes I visit
             Guitar Center since I play drums, guitar, and bass.  I listen to Classic Rock, KLOS radio in my car.`,
      id: 3,
    },
    {
      question: 'I social network on Facebook, Instagram, and Craigslist',
      answer: `I add to my social accounts, both information and photos. I buy and sell musical instruments
             guitars and parts. I sell them on Craigslist and have done so for some time. `,
      id: 4,
    },
    {
      question: 'I attent Social Meetups regularly',
      answer: `I like to be around programmers at Meetups and Clever Programmer in Santa Monica. I like discussing
             JavaScript, Database, Firebase, and Authentication. I like teaching and learning from people.  I have been
             writing software since my Cal Poly graduation in 1986. Recently I graduated as a JavaScript Master from 
             Clever Programmer. `,
      id: 5,
    },

    {
      question: 'Current Software Develop Projects',
      answer: `A major goal of mine is to interface my computer, tablet, phone, and watch together.
             I write in ReactJS, NextJS, and MERN technologies. I use Google Firebase for Authentication and database
             hosting. By connecting devices using REST and Firebase access the common single access is created. I write
             using ReactJS, SwiftUI, Xamarin, and MERN related technologies daily.`,
      id: 6,
    },
    {
      question: 'Github Copilot Version Software',
      answer: `Did you get your copy yet. An Artificial Intelligence sugessing ReactJS editing assistant! Great
             strides in programming have happened from use of my friends Copilot version. I am waiting for my version. Great
             work Github in producing a tool for assistance and learning the best from ReactJS. `,
      id: 7,
    },

    {
      question: 'I visit Corvette Clubs, Swap Meets, and outdoor events',
      answer: `The Corvette Club is in Santa Barbara and Huntington Beach. Since I love the beach
             I like to visit my old home town of Anaheim, CA.  huntington Beach is a great place for outdoor and indoor
             restaurants and meeting people.`,
      id: 8,
    },

    {
      question: 'Television and Movies',
      answer: `I have a 70" bigscreen and love it. I use it daily for my computer and watch Netflix and more.
             I like to visit Woodland Hills and Westwood, CA AMC theatre. Wanna visit me and lets go to the movies!
             A great summer pastime. The San Fernando Valley heat can be beat by going to Westwood and Santa Monica or 
             Malibu a half hour away!`,
      id: 9,
    },
    {
      question: '',
      answer: `OpenSea: the largest NFT marketplace.`,
      id: 10,
    },

    {
      question: 'I am a cook, I make salad daily for the  family',
      answer: `I buy food from Gelsons Markets and cut up a salad.`,
      id: 12,
    },

    {
      question: 'Current Software Development Projects',
      answer: ` James Avkaian Web, MyOneUinverse, and more. I write apps for my website, tablet, phone, and watch.  `,
      id: 13,
    },

    {
      question: 'Past Software Experiences',
      answer: ` I started with php/mysql web development. Then became a Mobile App developer
      First I started with Apple Swift for a year then moved to Xamarin with a single code base
      for Tablet and Phone and also iOS including Andriod outputs! Great program, app release
      coming. `,
      id: 14,
    },

    {
      question: '',
      answer: ` Crypto: you can buy regular goods and services.  `,
      id: 15,
    },

    {
      question: '',
      answer: ` Asset Class: can be a investment, like stocks or precious metals, but also can be risky. `,
      id: 16,
    },

    {
      question: '',
      answer: ` Crypto Wallet: money transfer, account, by telephone number, or QR code. `,
      id: 17,
    },

    {
      question: '',
      answer: ` Common Coins: Bitcoin, Ethereum and Dogecoin. `,
      id: 18,
    },

    {
      question: '',
      answer: ` Best Crypto Exchanges:  January 2022, 		Binance.US. `,
      id: 19,
    },

    {
      question: '',
      answer: ` Beginner Exchanges: CoinBase. `,
      id: 20,
    },

    {
      question: '',
      answer: ` More Exchanges: bitFlyer, 	Bitstamp, Bittrex, Global, Crypto.com, Gate.io, Gemini, Kraken, KuCoin. `,
      id: 21,
    },

    {
      question: '',
      answer: ` Exchange transaction fees, dependent on your purchase amount with convenience fee of 0.5%. `,
      id: 22,
    },
  ]);

  return (
    <div className="home">
      <div className="faqWrapper">
        <div className="faqWrapper2">
          <h1 className="faqTitle">Welcome to my Website!</h1>
        </div>
        <div className="darkGlassCard faqContainer">
          <div className="space"> </div>
          <div className="space"> </div>

          <div className="scroll-container">
            <div className="scroll-text">I Make New Websites !</div>
          </div>
          <>
            <div className="space"> </div>
            <div className="space"> </div>
            {/* <div className="linkcenter">
              <NavLink to="/React" className={`navMenuItem`}>
                React
              </NavLink>
              <NavLink to="/React2" className={`navMenuItem`}>
                React2
              </NavLink>
              <NavLink to="/Products" className={`navMenuItem`}>
                Products
              </NavLink>
              <NavLink to="/Technology" className={`navMenuItem`}>
                Technology
              </NavLink>
            </div> */}
            <div className="space"> </div>
            <div className="space"> </div>
          </>

          {/* //Map through the FAQs and display them */}
          {faqs.map((faq) => {
            return (
              <Faq key={faq.id} question={faq.question} answer={faq.answer} />
            );
          })}
          <>
            <div className="space"> </div>
            <div className="space"> </div>
            {/* <div className="linkcenter">
              <NavLink to="/React" className={`navMenuItem`}>
                React
              </NavLink>
              <NavLink to="/React2" className={`navMenuItem`}>
                React2
              </NavLink>
              <NavLink to="/Products" className={`navMenuItem`}>
                Products
              </NavLink>
              <NavLink to="/Technology" className={`navMenuItem`}>
                Technology
              </NavLink>
            </div> */}
            <div className="space"> </div>
            <div className="space"> </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default Home;
